import React from 'react';
import { StyledImageBlock, StyledSquareImage } from '../../../Styled/StyledButtons';
import { SelectedImageIcon } from '../../../../assets/icons/ImageEditTool';

interface ISquareImage {
  src: string;
  color: string;
  isSelected: boolean;
  onClick: (event: React.MouseEvent<HTMLImageElement>) => void;
}

export const SquareImage = (props: ISquareImage): JSX.Element => {
  const { src, isSelected, color, onClick } = props;

  return (
    <StyledImageBlock>
      <StyledSquareImage
        data-testid="relationship-img"
        src={src}
        alt="default_image"
        color={color}
        selected={isSelected}
        onClick={onClick}
      />
      {isSelected && <SelectedImageIcon color={color} />}
    </StyledImageBlock>
  );
};
